(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-ugc-gallery';
  var initedSections = new WeakMap();

  function initSection(section) {
    if (!section || initedSections.has(section)) return;

    var viewport = section.querySelector('.oddit-section-ugc-gallery__viewport');
    var track = section.querySelector('.oddit-section-ugc-gallery__track');
    var prevBtn = section.querySelector('[data-ugc-prev]');
    var nextBtn = section.querySelector('[data-ugc-next]');
    var thumb = section.querySelector('[data-ugc-thumb]');

    if (!viewport || !track || !prevBtn || !nextBtn) return;

    function getScrollStep() {
      var firstCard = track.querySelector('.oddit-section-ugc-gallery__card');
      if (!firstCard) return viewport.clientWidth * 0.8;
      var cardWidth = firstCard.getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0');
      return cardWidth + gap;
    }

    function updateButtons() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var current = viewport.scrollLeft;
      prevBtn.disabled = current <= 1;
      nextBtn.disabled = current >= maxScroll - 1;
    }

    function updateThumb() {
      if (!thumb) return;
      var scrollWidth = viewport.scrollWidth;
      var clientWidth = viewport.clientWidth;
      if (scrollWidth <= clientWidth) {
        thumb.style.width = '100%';
        thumb.style.left = '0';
        return;
      }
      var ratio = clientWidth / scrollWidth;
      var maxScroll = scrollWidth - clientWidth;
      var progress = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.left = ((1 - ratio) * 100 * progress) + '%';
    }

    function update() {
      updateButtons();
      updateThumb();
    }

    function onPrev() {
      viewport.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    }

    function onNext() {
      viewport.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', onPrev);
    nextBtn.addEventListener('click', onNext);
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    initedSections.set(section, {
      destroy: function () {
        prevBtn.removeEventListener('click', onPrev);
        nextBtn.removeEventListener('click', onNext);
        viewport.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      }
    });

    update();
  }

  function destroySection(section) {
    if (!section) return;
    var state = initedSections.get(section);
    if (state && typeof state.destroy === 'function') {
      state.destroy();
    }
    initedSections.delete(section);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) destroySection(section);
  });
})();
